// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","913":"BusinessProGuestLazyComponent"}[chunkId] + "." + {"46":"d01bff2a0e513a724ed4","913":"39852b672dac92930abc"}[chunkId] + ".js";
};